import { Link } from "react-router";
import { FooterMenuLinksProps } from "@events-awards/EventsAwardsFooterComponents/types";
import { cn } from "@util/helpers";

/**
 * Component to render footer links for footer component in Events and Awards pages
 */
const FooterMenuLinks = ({
  items,
  className,
}: FooterMenuLinksProps): React.ReactElement => {
  return (
    <div
      className={cn("flex flex-col", className)}
      data-testid="footer-menu-links-component"
    >
      {items.map((item) => (
        <Link
          to={`${item.link}?ref=footer`}
          key={item.label}
          className="text-left text-base text-white hover:text-white/75"
          reloadDocument
        >
          {item.label}
        </Link>
      ))}
    </div>
  );
};

export default FooterMenuLinks;
